import React, { ReactNode } from 'react';
import { AnimatedDashboardWrapper } from './AnimatedDashboardStyled';

export const AnimatedDashboard = ({
  children,
  zoom,
  dark,
  style
}: {
  children: ReactNode;
  zoom?: boolean;
  dark?: boolean;
  style?: React.CSSProperties;
}) => {
  return (
    <AnimatedDashboardWrapper
      zoom={zoom}
      dark={dark}
      initial={{ opacity: 0, marginTop: -20 }}
      animate={{ opacity: 1, marginTop: 20 }}
      exit={{ opacity: 0, marginTop: 60 }}
      transition={{
        duration: 0.2
      }}
      style={style}>
      {children}
    </AnimatedDashboardWrapper>
  );
};
